import React from "react";
import { ExternalPopup } from "../../externalWindow/externalWindow";
import { connect } from "react-redux";
import * as actions from "../../../actions";

class RedocAuthPopup extends React.Component {
  state = {
    success: null,
  };

  componentDidMount() {
    const { url } = this.props;
    this.setState({ url });
    this.props.clearAuthCode();
  }

  onUnload = () => {
    const { success } = this.state;
    if (!success) {
      this.props.onFail();
    }
  };

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    const { authCode, onSuccess, onFail } = nextProps;
    if (
      authCode &&
      authCode.code &&
      authCode.code !== this.props.authCode.code
    ) {
      onSuccess({
        code: authCode.code,
      });
      this.setState({
        success: true,
      });
    } else if (
      authCode &&
      authCode.error &&
      authCode.error !== this.props.authCode.error
    ) {
      onFail();
    }
  }

  render() {
    const { url } = this.state;
    return url ? (
      <ExternalPopup
        copyStyles={false}
        url={url}
        onUnload={this.onUnload}
        title="Authorize"
      />
    ) : null;
  }
}

const parseAuthCode = (authCode) => {
  if (!authCode) return {};

  // Helper to safely access properties whether they're plain objects or Immutable
  const getValue = (obj, key) => {
    if (!obj) return undefined;
    // If obj has get method (Immutable), use it
    if (typeof obj.get === "function") {
      return obj.get(key);
    }
    // Otherwise, access plain object property
    return obj[key];
  };

  return {
    code: getValue(authCode, "code"),
    error: getValue(authCode, "error"),
  };
};

const mapStateToProps = (state) => {
  // Helper to safely access properties whether they're plain objects or Immutable
  const getValue = (obj, key) => {
    if (!obj) return undefined;
    // If obj has get method (Immutable), use it
    if (typeof obj.get === "function") {
      return obj.get(key);
    }
    // Otherwise, access plain object property
    return obj[key];
  };

  const authCode = getValue(state.tryout, "authCode");
  return {
    authCode: parseAuthCode(authCode),
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearAuthCode: (payload) => {
    dispatch(actions.clearAuthCode(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RedocAuthPopup);
